module.exports = __webpack_public_path__ + "static/media/twitter.f2878588.png";